// // export default AuthPage;

// import { useState } from "react";
// import axios from "axios";
// import { BASE_URL } from "./baseUrl";
// import { ToastContainer, toast } from "react-toastify";
// import { useNavigate } from "react-router-dom";

// function AuthPage() {

// const [email, setEmail] = useState("");
// const [password, setPassword] = useState("");

// const navigate = useNavigate();

// const handleSubmit = async (e) => {
//     e.preventDefault();

//     if (!email) {
//         toast.error("Please enter email", { containerId: "authPage" });
//         return;
//     }

//     if (!password) {
//         toast.error("Please enter password", { containerId: "authPage" });
//         return;
//     }

//     try {
//         const res = await axios.post(
//             BASE_URL + "/admin/login",
//             {
//                 email: email,
//                 password: password,
//             }
//         );

//         localStorage.setItem("token", res.data.token);

//         toast.success("Login successful", {
//             containerId: "authPage",
//         });

//         setEmail("");
//         setPassword("");

//         setTimeout(() => {
//             navigate("/");
//         }, 1500);

//     } catch (error) {

//         if (error?.response?.data?.error) {
//             toast.error(error.response.data.error, {
//                 containerId: "authPage",
//             });
//         } else {
//             toast.error("Login failed", {
//                 containerId: "authPage",
//             });
//         }

//     }
// };

// return (
//     <>
//         <ToastContainer containerId="authPage" />

//         <div className="min-h-screen bg-gradient-to-b from-blue-200 to-blue-500 flex justify-center items-center p-8">

//             <div className="w-full max-w-md bg-white shadow-2xl rounded-xl p-8 border border-gray-300">

//                 <h2 className="text-3xl font-extrabold text-gray-900 text-center mb-6">
//                     Login
//                 </h2>

//                 <form onSubmit={handleSubmit} className="space-y-4">

//                     <input
//                         type="email"
//                         placeholder="Email"
//                         value={email}
//                         onChange={(e) => setEmail(e.target.value)}
//                         className="w-full p-3 border border-gray-300 rounded-lg"
//                     />

//                     <input
//                         type="password"
//                         placeholder="Password"
//                         value={password}
//                         onChange={(e) => setPassword(e.target.value)}
//                         className="w-full p-3 border border-gray-300 rounded-lg"
//                     />

//                     <button
//                         type="submit"
//                         className="w-full p-3 bg-blue-600 text-white font-medium rounded-lg hover:bg-blue-700 transition"
//                     >
//                         Login
//                     </button>

//                 </form>

//             </div>

//         </div>
//     </>
// );

// }

// export default AuthPage;

import { useMemo, useState } from "react";
import axios from "axios";
import { BASE_URL } from "./baseUrl";
import { ToastContainer, toast } from "react-toastify";
import { useNavigate } from "react-router-dom";
import {
  FiShield,
  FiLock,
  FiMail,
  FiEye,
  FiEyeOff,
  FiLayers,
  FiUsers,
  FiCreditCard,
} from "react-icons/fi";
import "react-toastify/dist/ReactToastify.css";

function AuthPage() {
  const [email, setEmail] = useState("");
  const [password, setPassword] = useState("");
  const [showPassword, setShowPassword] = useState(false);
  const [isSubmitting, setIsSubmitting] = useState(false);

  const navigate = useNavigate();

  const currentYear = useMemo(() => new Date().getFullYear(), []);

  const handleSubmit = async (e) => {
    e.preventDefault();

    if (!email.trim()) {
      toast.error("Please enter email", { containerId: "authPage" });
      return;
    }

    if (!password.trim()) {
      toast.error("Please enter password", { containerId: "authPage" });
      return;
    }

    try {
      setIsSubmitting(true);

      const res = await axios.post(`${BASE_URL}/admin/login`, {
        email: email.trim(),
        password,
      });

      localStorage.setItem("token", res.data.token);

      toast.success("Login successful", {
        containerId: "authPage",
      });

      setEmail("");
      setPassword("");

      setTimeout(() => {
        navigate("/");
      }, 1000);
    } catch (error) {
      if (error?.response?.data?.error) {
        toast.error(error.response.data.error, {
          containerId: "authPage",
        });
      } else {
        toast.error("Login failed", {
          containerId: "authPage",
        });
      }
    } finally {
      setIsSubmitting(false);
    }
  };

  return (
    <>
      <ToastContainer
        containerId="authPage"
        position="top-right"
        autoClose={2500}
        hideProgressBar={false}
        newestOnTop
        closeOnClick
        pauseOnHover
        draggable
        theme="light"
      />

      <div className="min-h-screen bg-slate-950 text-slate-100">
        <div className="relative min-h-screen overflow-hidden">
          <div className="absolute inset-0 bg-[radial-gradient(circle_at_top_left,_rgba(168,85,247,0.28),_transparent_32%),radial-gradient(circle_at_bottom_right,_rgba(59,130,246,0.24),_transparent_30%),linear-gradient(135deg,#020617_0%,#0f172a_42%,#111827_100%)]" />

          <div className="absolute inset-0 opacity-[0.08] [background-image:linear-gradient(rgba(255,255,255,0.25)_1px,transparent_1px),linear-gradient(90deg,rgba(255,255,255,0.25)_1px,transparent_1px)] [background-size:48px_48px]" />

          <div className="relative z-10 mx-auto flex min-h-screen max-w-7xl flex-col px-6 py-8 lg:px-8">
            <header className="flex items-center justify-between">
              <div className="flex items-center gap-3">
                <div className="flex h-11 w-11 items-center justify-center rounded-2xl border border-white/15 bg-white/10 shadow-lg shadow-purple-900/20 backdrop-blur">
                  <FiShield className="text-xl text-violet-300" />
                </div>

                <div>
                  <div className="text-xl font-bold tracking-tight text-white">
                    E-Lex Signature
                  </div>
                  <div className="text-sm text-slate-300">Platform Admin</div>
                </div>
              </div>

              <div className="hidden rounded-full border border-emerald-400/20 bg-emerald-400/10 px-4 py-2 text-sm text-emerald-200 md:block">
                Restricted access • Super Admins only
              </div>
            </header>

            <main className="flex flex-1 items-center py-8 lg:py-12">
              <div className="grid w-full items-stretch gap-8 lg:grid-cols-2">
                <section className="order-2 flex items-center lg:order-1">
                  <div className="w-full max-w-xl">
                    <div className="mb-8">
                      <div className="mb-4 inline-flex items-center gap-2 rounded-full border border-violet-400/20 bg-violet-400/10 px-4 py-2 text-sm font-medium text-violet-200">
                        <FiLock className="text-base" />
                        Secure administrative access
                      </div>

                      <h1 className="max-w-lg text-4xl font-semibold leading-tight text-white md:text-5xl">
                        Control your signing platform from one place
                      </h1>

                      <p className="mt-4 max-w-xl text-base leading-7 text-slate-300 md:text-lg">
                        Manage organizations, plans, platform users, and system
                        access from the E-Lex admin console.
                      </p>
                    </div>

                    <div className="grid gap-4 sm:grid-cols-3">
                      <div className="rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm">
                        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-violet-500/15 text-violet-200">
                          <FiLayers className="text-lg" />
                        </div>
                        <h3 className="text-sm font-semibold text-white">
                          Organizations
                        </h3>
                        <p className="mt-1 text-sm leading-6 text-slate-300">
                          Create and manage client workspaces.
                        </p>
                      </div>

                      <div className="rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm">
                        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-sky-500/15 text-sky-200">
                          <FiUsers className="text-lg" />
                        </div>
                        <h3 className="text-sm font-semibold text-white">
                          Access control
                        </h3>
                        <p className="mt-1 text-sm leading-6 text-slate-300">
                          Control super admins, org admins, and permissions.
                        </p>
                      </div>

                      <div className="rounded-2xl border border-white/10 bg-white/5 p-4 backdrop-blur-sm">
                        <div className="mb-3 flex h-10 w-10 items-center justify-center rounded-xl bg-emerald-500/15 text-emerald-200">
                          <FiCreditCard className="text-lg" />
                        </div>
                        <h3 className="text-sm font-semibold text-white">
                          Platform plans
                        </h3>
                        <p className="mt-1 text-sm leading-6 text-slate-300">
                          Review pricing, subscriptions, and platform controls.
                        </p>
                      </div>
                    </div>

                    <div className="mt-8 flex flex-wrap items-center gap-3 text-sm text-slate-400">
                      <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5">
                        Encrypted authentication
                      </span>
                      <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5">
                        Role-based access
                      </span>
                      <span className="rounded-full border border-white/10 bg-white/5 px-3 py-1.5">
                        Audit-ready operations
                      </span>
                    </div>
                  </div>
                </section>

                <section className="order-1 flex items-center justify-center lg:order-2 lg:justify-end">
                  <div className="w-full max-w-md">
                    <div className="rounded-[28px] border border-white/10 bg-white/10 p-2 shadow-2xl shadow-black/30 backdrop-blur-xl">
                      <div className="rounded-[24px] border border-white/10 bg-slate-950/70 p-6 sm:p-8">
                        <div className="mb-6 flex items-start justify-between gap-4">
                          <div>
                            <div className="mb-2 inline-flex items-center gap-2 rounded-full border border-violet-400/20 bg-violet-400/10 px-3 py-1 text-xs font-semibold uppercase tracking-[0.18em] text-violet-200">
                              Super Admin
                            </div>

                            <h2 className="text-3xl font-semibold tracking-tight text-white">
                              Welcome back
                            </h2>

                            <p className="mt-2 text-sm leading-6 text-slate-300">
                              Sign in to manage organizations, plans, and
                              platform settings.
                            </p>
                          </div>

                          <div className="hidden h-12 w-12 items-center justify-center rounded-2xl border border-white/10 bg-white/5 text-violet-200 sm:flex">
                            <FiShield className="text-xl" />
                          </div>
                        </div>

                        <form onSubmit={handleSubmit} className="space-y-5">
                          <div>
                            <label
                              htmlFor="admin-email"
                              className="mb-2 block text-sm font-medium text-slate-200"
                            >
                              Email address
                            </label>

                            <div className="relative">
                              <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-slate-400">
                                <FiMail />
                              </span>

                              <input
                                id="admin-email"
                                type="email"
                                placeholder="admin@elexsignature.com"
                                value={email}
                                onChange={(e) => setEmail(e.target.value)}
                                autoComplete="email"
                                className="w-full rounded-2xl border border-white/10 bg-white/5 py-3 pl-11 pr-4 text-white outline-none transition placeholder:text-slate-500 focus:border-violet-400/60 focus:bg-white/10 focus:ring-4 focus:ring-violet-500/10"
                              />
                            </div>
                          </div>

                          <div>
                            <div className="mb-2 flex items-center justify-between">
                              <label
                                htmlFor="admin-password"
                                className="block text-sm font-medium text-slate-200"
                              >
                                Password
                              </label>

                              <span className="text-xs text-slate-400">
                                Protected session
                              </span>
                            </div>

                            <div className="relative">
                              <span className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-4 text-slate-400">
                                <FiLock />
                              </span>

                              <input
                                id="admin-password"
                                type={showPassword ? "text" : "password"}
                                placeholder="Enter your password"
                                value={password}
                                onChange={(e) => setPassword(e.target.value)}
                                autoComplete="current-password"
                                className="w-full rounded-2xl border border-white/10 bg-white/5 py-3 pl-11 pr-12 text-white outline-none transition placeholder:text-slate-500 focus:border-violet-400/60 focus:bg-white/10 focus:ring-4 focus:ring-violet-500/10"
                              />

                              <button
                                type="button"
                                onClick={() => setShowPassword((prev) => !prev)}
                                className="absolute inset-y-0 right-0 flex items-center pr-4 text-slate-400 transition hover:text-white"
                                aria-label={
                                  showPassword ? "Hide password" : "Show password"
                                }
                              >
                                {showPassword ? <FiEyeOff /> : <FiEye />}
                              </button>
                            </div>
                          </div>

                          <button
                            type="submit"
                            disabled={isSubmitting}
                            className="group relative inline-flex w-full items-center justify-center overflow-hidden rounded-2xl bg-gradient-to-r from-violet-500 via-fuchsia-500 to-indigo-500 px-5 py-3.5 text-sm font-semibold text-white shadow-lg shadow-violet-900/30 transition duration-200 hover:scale-[1.01] hover:shadow-violet-900/40 disabled:cursor-not-allowed disabled:opacity-70"
                          >
                            <span className="absolute inset-0 bg-white/10 opacity-0 transition group-hover:opacity-100" />
                            <span className="relative">
                              {isSubmitting ? "Signing in..." : "Sign in to Admin Console"}
                            </span>
                          </button>
                        </form>

                        <div className="mt-6 rounded-2xl border border-amber-400/15 bg-amber-400/10 px-4 py-3 text-sm text-amber-100">
                          <div className="font-medium">Restricted access</div>
                          <div className="mt-1 text-amber-50/80">
                            This portal is for authorized E-Lex platform
                            administrators only.
                          </div>
                        </div>
                      </div>
                    </div>

                    <p className="mt-4 text-center text-sm text-slate-400">
                      © {currentYear} E-Lex Signature • Admin Console
                    </p>
                  </div>
                </section>
              </div>
            </main>
          </div>
        </div>
      </div>
    </>
  );
}

export default AuthPage;